/* eslint-disable no-redeclare */
export function combineOr<TIn>(func: ((a: TIn) => boolean)[]): (a: TIn) => boolean;
export function combineOr<TIn, TIn2>(func: ((a: TIn, b: TIn2) => boolean)[]): (a: TIn, b: TIn2) => boolean;
export function combineOr<TIn, TIn2, TIn3>(func: ((a: TIn, b: TIn2, c: TIn3) => boolean)[]): (a: TIn, b: TIn2, c: TIn3) => boolean;
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function combineOr(func: ((...args: any[]) => boolean)[]): (...args: any[]) => boolean {
  return (...args) => func.reduce((acc, f) => acc || f(...args), false);
}
